import { Button, Stack, TextField } from '@mui/material';
import { ChangeEvent } from 'react';
import { ImportPipelineType } from './types';
import { Trans, useTranslation } from 'react-i18next';

export const defaultImportFormData = {
  name: '',
  file: null,
};

type Props = {
  data: ImportPipelineType;
  onChange: (data: ImportPipelineType) => void;
};

const ImportPipeline = ({ data, onChange }: Props): JSX.Element => {
  const { t } = useTranslation();

  const handleNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange({ ...data, name: event.target.value });
  };

  const handleFileSelection = (event: ChangeEvent<HTMLInputElement>) => {
    onChange({ ...data, file: event.target?.files?.[0] ?? null });
  };

  return (
    <>
      <TextField variant={'filled'} label={t('Name')} value={data.name} onChange={handleNameChange} fullWidth />
      <Stack direction={'row'} spacing={2}>
        <Button variant={'contained'} component={'label'}>
          <Trans>Upload File</Trans>
          <input type={'file'} onChange={handleFileSelection} hidden />
        </Button>
        <TextField
          sx={{ flexGrow: 1 }}
          label={t('Filename')}
          variant={'filled'}
          value={data.file?.name ?? ''}
          InputProps={{
            readOnly: true,
          }}
        />
      </Stack>
    </>
  );
};

export default ImportPipeline;
